// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__24yyC","notes":"Notes_notes__2U_Qh","note":"Notes_note__3eQBG","markdown":"Notes_markdown__3M1Wz"};